<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :append-to-body="true"
        :destroy-on-close="true"
        width="600px"
        top="5vh"
        class="dialog-join-in"
        custom-class="dialog-join-in"
    >   
        <div class="dialog-join-in-body">
            <div class="bg-view">
                <img :src="require('./img/join-bg (1).jpg')" alt="">
                <img :src="require('./img/join-bg (2).jpg')" alt="">
                <img :src="require('./img/join-bg (3).jpg')" alt="">
                <img :src="require('./img/join-bg (4).jpg')" alt="">
                <img :src="require('./img/join-bg (5).jpg')" alt="">
                <img :src="require('./img/join-bg (6).jpg')" alt="">
                <img :src="require('./img/join-bg (7).jpg')" alt="">
                <img :src="require('./img/join-bg (8).jpg')" alt="">
            </div>
            <div class="btn-view">
                <div class="down-load-pdf" @click="openPdf">下载方案书</div>
                <div class="down-load-pdf" @click="addWechat">点击扫码加微信</div>
                <div class="add-qrcode-text">（请务必扫码加微信）</div>
            </div>
            
            <img :src="require('./img/join-from.png')" alt="" class="join-form-img">
            <div class="join-form-view">
                <div class="form-label">您的姓名：</div>
                <el-input v-model="formData.fullName" placeholder="请输入您的姓名"></el-input>
                <div class="form-label">您的电话：</div>
                <el-input v-model="formData.phone" placeholder="请输入正确的手机号码"></el-input>
                <div class="form-label">所在城市：</div>
                <el-input v-model="formData.address" placeholder="请输入您所在的城市"></el-input>
                <div class="form-submit" @click="submit">
                    <img :src="require('./img/join-btn.png')" alt="" />
                </div>
            </div>
            <div class="join-tip-view">
                注：报名后，按城市巡回，线下培训讲解模式与具体运营方式。
            </div>
            <div class="join-wxqrcode-view">
                <img :src="require('./img/wxqrcode.jpg')" alt="">
                <p>资料索取请扫描二维码</p>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {Loading,Message} from 'element-ui'
import {WinForm} from '@digital-supply-chain/module'
import {ApiService} from '@/libs'
import {PartnerService,UserService} from '@/service'

  export default {
    data() {
      return {
        dialogVisible: false,
        formData: {
            fullName: '',
            phone: '',
            address: '',
        }
      };
    },
    methods: {
        open() {
            this.formData = {
                fullName: '',
                phone: '',
                address: '',
            };
            const Phone = UserService.user().Phone;
            Phone && (this.formData.phone = Phone);
            this.dialogVisible = true;
        },
        close() {
			this.dialogVisible = false;
		},
        openPdf() {
            WinForm.md.openUrl(`${ApiService.OssHzHost}/jrzz/home_ad/工程师代理人方案20230327.pdf`);
        },
        addWechat() {
            const ele = document.querySelector('.dialog-join-in');
            const scrollHeight = ele.scrollHeight;
            ele.scrollTop = scrollHeight;
        },
        async submit() {
            let err = '';
            Object.values(this.formData).forEach(item => {
                if (!item) {
                    err = '请先填写完整的信息';
                }
                if (item && item.length < 2) {
                    err = '请填写正确的信息';
                }
            })
            if (!err && !/^(?:(?:\+|00)86)?1\d{10}$/g.test(this.formData.phone)) {
                err = '请填写正确的手机号';
            }
            if (err) {
                Message.warning(err);
                return;
            }
            const loading = Loading.service({
                text: '提交中...',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            const res = await PartnerService.saveEnroll(
                this.formData.fullName,
                this.formData.phone,
                this.formData.address,
            );
            loading.close();
            if (res.code == 0) {
                this.formData = {
                    fullName: '',
                    phone: '',
                    address: '',
                };
                Message.success('信息提交成功');
            } else {
                Message.error(res.massage || '信息提交出错，请稍后再试');
            }
        }
    }
  };
</script>

<style lang="less">
    .dialog-join-in{
        .dialog-join-in-body{
            
        }
        .bg-view{
            border-radius: 6px;
            overflow: hidden;
            position: relative;
            z-index: 0;
            font-size: 0;
            img{
                width: 100%;
            }
        }
        .btn-view{
            position: absolute;
            left: 50%;
            margin-left: 40px;
            top: 820px;
            z-index: 2;
        }
        .down-load-pdf{
            color: #ffffff;
            font-size: 18px;
            border: 1px solid #fff;
            cursor: pointer;
            width: 150px;
            height: 38px;
            line-height: 36px;
            text-align: center;
            border-radius: 4px;
            margin-top: 20px;
        }
        .add-qrcode-text{
            text-align: center;
            color: #ffffff;
            font-size: 14px;
            margin-top: 10px;
        }
        .down-load-pdf:hover{
            background-color: #b07834;
            border: 1px solid #b07834;
        }
        .join-form-img,.join-form-view{
            position: absolute;
            z-index: 1;
            width: 550px;
            height: 630px;
            left: 25px;
            bottom: 360px;
        }
        .join-form-view{
            z-index: 2;
            padding: 90px 55px 0 55px;
        }
        .form-label{
            color: #ffffff;
            font-size: 22px;
            margin-top: 36px;
            margin-bottom: 20px;
        }
        .el-input__inner{
            height: 50px;
            background-color: #F7DAB7;
            border: 1px solid #DCDFE6!important;
            color: #757575;
            font-size: 18px;
            &::placeholder{
                color: #757575;
            }
        }
        .form-submit{
            width: 440px;
            height: 62px;
            font-size: 0;
            cursor: pointer;
            margin-top: 36px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .join-tip-view{
            position: absolute;
            left: 0;
            bottom: 310px;
            width: 100%;
            text-align: center;
            font-size: 14px;
            color: #E4C4B9;
        }
        .join-wxqrcode-view{
            position: absolute;
            left: 0;
            bottom: 60px;
            width: 100%;
            text-align: center;
            font-size: 12px;
            color: #E4C4B9;
            img{
                width: 150px;
                height: 143px;
            }
        }

        &.el-dialog{
            background: #ecf5ff;
            border-radius: 6px;
        }
        .el-dialog__header{
            padding: 0;
            position: relative;
            z-index: 2;
            i{
                color: #fff;
            }
        }
        .el-dialog__body{
            padding: 0;
        }
        .el-dialog__footer{
            text-align: center;
            width: 100%;
            display: block;
        }
        .el-dialog__headerbtn{
            top: 10px;
            right: 10px;
            font-size: 20px;
        }
    }
</style>
